import {createData, Image} from '@/imports-files/pages/clients/manage-integration';

// ---------------------------- IMAGES -----------------------------------------
import GmailImage from 'public/images/pages/integration/gmail.png';
import CronofyImage from 'public/images/pages/integration/cronofy.png'
import SlackImage from 'public/images/pages/integration/slack.png'
import ZoomImage from 'public/images/pages/integration/zoom.png';
// ---------------------------- IMAGES -----------------------------------------



export const ROWS = [
  createData(
    "Email Account",
    <Image src={GmailImage} alt="" height={19} width={26}></Image>,
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore  et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco",
    "Connect"
  ),
  createData(
    "Calendar (Via Cronofy)",
    <Image src={CronofyImage} alt="" height={25} width={97}></Image>,
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore  et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco",
    "Connect"
  ),
  createData(
    "Slack",
    <Image src={SlackImage} alt="" height={23} width={90}></Image>,
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore  et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco",
    "Connect"
  ),

  createData(
    "Zoom or Teams",
    <Image src={ZoomImage} alt="" height={26} width={92}></Image>,
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore  et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco",
    "Connect"
  ),
];
